/** Owner decision, 31 October: announce from 5 November, midnight Europe/Berlin. */
export const BLACK_FRIDAY_ANNOUNCEMENT_START = "2026-11-04T23:00:00Z";

export interface BlackFridayCampaignConfig {
	key: "black-friday-2026";
	timeZone: "Europe/Berlin";
	utcOffset: "+01:00";
	dates: { earlyAccess: "2026-11-25"; publicStart: "2026-11-27"; endExclusive: "2026-12-01" };
	channels: ReadonlyArray<{ slug: string; currency: "EUR" | "USD"; discountPercent: number }>;
	productSlugs: readonly string[];
	/** Established authored copy; staging availability is checked only on the server. */
	copyLocales: readonly string[];
	signupSource: "black-friday-early-access";
	promotionName: "Black Friday 2026";
	priceOverrideReason: "Black Friday 2026 Früher Zugang";
	mails: ReadonlyArray<{
		key: "black-friday-2026-start" | "black-friday-2026-public" | "black-friday-2026-last-chance";
		sendFromUtc: string;
		sendUntilUtc: string;
		audience: "newsletter";
	}>;
}

// Prices come from the channel; quotas are maintained separately by the owner.
export const BLACK_FRIDAY_CAMPAIGN_CONFIG: BlackFridayCampaignConfig = {
	key: "black-friday-2026",
	timeZone: "Europe/Berlin",
	utcOffset: "+01:00",
	dates: {
		earlyAccess: "2026-11-25",
		publicStart: "2026-11-27",
		endExclusive: "2026-12-01",
	},
	channels: [{ slug: "standard", currency: "EUR", discountPercent: 12 }],
	productSlugs: ["retatrutide", "tirzepatid"],
	copyLocales: [
		"de",
		"en",
		"es",
		"tr",
		"fr",
		"it",
		"nl",
		"pl",
		"pt",
		"sv",
		"da",
		"cs",
		"nb",
		"el",
		"fi",
		"hr",
		"et",
		"lv",
	],
	signupSource: "black-friday-early-access",
	promotionName: "Black Friday 2026",
	priceOverrideReason: "Black Friday 2026 Früher Zugang",
	mails: [
		{
			key: "black-friday-2026-start",
			sendFromUtc: "2026-11-25T07:00:00Z",
			sendUntilUtc: "2026-11-25T23:00:00Z",
			audience: "newsletter",
		},
		{
			key: "black-friday-2026-public",
			sendFromUtc: "2026-11-27T07:00:00Z",
			sendUntilUtc: "2026-11-27T23:00:00Z",
			audience: "newsletter",
		},
		{
			key: "black-friday-2026-last-chance",
			sendFromUtc: "2026-11-30T09:00:00Z",
			sendUntilUtc: "2026-11-30T23:00:00Z",
			audience: "newsletter",
		},
	],
};
